import React from 'react';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Icon from './Icon';
import { formatCentsToUSD } from '../../../../../../../shared/lib/utils';
import { ReservableEventTemplate } from '../../../../../../../shared/types/reservable';
import { PropertyZone } from '../../../../../../../shared/types/property';
import Button from './Button';
import WideImage from './WideImage';

interface EventCardPropsBase {
  template: ReservableEventTemplate;
  tag?: any;
  zones?: PropertyZone[];
  onBook: (template: ReservableEventTemplate) => void;
}

type EventCardProps = EventCardPropsBase & React.HTMLAttributes<HTMLDivElement>;

export default function EventCard(props: EventCardProps) {
  const { template, tag, zones, onBook, className: propClasses, ...rest } = props;

  const { images, title, reservables } = template;
  const imageUrl = images[0];
  const price = reservables.marketingPrice;
  const time = reservables.marketingDuration;
  const occupancy = reservables.marketingCapacity;

  const classes = [
    'relative bg-white border border-border rounded-lg overflow-hidden h-full flex flex-col',
  ];
  if (propClasses) classes.push(propClasses);

  classes.push('go-event-card');

  return (
    <div className={classes.join(' ')} {...rest}>
      <WideImage image={imageUrl} title={title} tags={tag ? [tag] : []} className="rounded-0-i" />
      <div className="h-full flex flex-col gap-6 p-4">
        <div className="grid grid-cols-1 gap-4">
          <div>
            {zones && zones.length > 0 && (
              <div className="flex flex-wrap gap-1 mb-1 go-event-zones">
                {zones.map(z => (
                  <div
                    key={z._id}
                    className="text-white shrink-0 min-w-0 bg-black text-sm font-bold rounded-full px-2 py-0 truncate go-event-zone"
                    style={{ backgroundColor: z.color }}
                  >
                    {z.name}
                  </div>
                ))}
              </div>
            )}
            <div className="text-lg font-bold text-accent">{title}</div>
          </div>
          <div className="grid grid-cols-1 gap-2">
            <Icon
              icon={['fass', 'ticket']}
              text={price || `From ${formatCentsToUSD(reservables.tickets[0]?.price ?? 0)}`}
            />
            {time && <Icon icon={['fass', 'clock']} text={time} />}
            {occupancy && <Icon icon={['fass', 'user-group-simple']} text={occupancy} />}
          </div>
        </div>
        <Button
          onClick={() => onBook(template)}
          block
          iconSuffix={['fass', 'arrow-right']}
          className="stretched-link mt-auto"
        >
          Book Now
        </Button>
      </div>
    </div>
  );
}
